export enum AUTH_INDICATOR {
    OK = 'OK',
    IS_CLIENT = 'IS_CLIENT',
    REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS',
    ATTEMPTS_EXHAUSTED = 'ATTEMPTS_EXHAUSTED',
    UNFINISHED_TRIP_BEFORE_42_DAYS = 'UNFINISHED_TRIP_BEFORE_42_DAYS',
    UNFINISHED_TRIP_AFTER_42_DAYS = 'UNFINISHED_TRIP_AFTER_42_DAYS',
    ERROR = 'ERROR',
    SS_EN_CURSO = 'SS_EN_CURSO',
    EMPTY_STRING = '',
    IS_RETOMA = 'retoma',
    BLOQUEO_EMPRESA_UN_DIA = 'BLOQUEO_EMPRESA_UN_DIA',
    BLOQUEO_EJECUTIVO_PRODUCTO = 'BLOQUEO_EJECUTIVO_PRODUCTO',
    INTENTOS_AGOTADOS = 'INTENTOS_AGOTADOS',
    SOLICITUD_MARCADA_COMO_AUTOATENCION = 'SOLICITUD_MARCADA_COMO_AUTOATENCION',
    SOLICITUD_ASIGNADA_A_EJECUTIVO = 'SOLICITUD_ASIGNADA_A_EJECUTIVO',
    EJECUTIVO_ASIGNADO_NO_COINCIDE = 'EJECUTIVO_ASIGNADO_NO_COINCIDE',
    FALTA_CI_RETOMA = 'FALTA_CI_RETOMA',
    ERROR_DATOS_INCORRECTOS = "ERROR_DATOS_INCORRECTOS",
    PRODUCTO_SELECCIONADO_VACIO = "PRODUCTO_SELECCIONADO_VACIO",
    RETOMA_TBK_AMIGO = "RETOMA_TBK_AMIGO"
  }